import {createAsyncThunk} from '@reduxjs/toolkit'

import {BankCodeType} from '@web/core/constants'

import {changeBank} from './apis'

const BankAccountChangeFailMessage = '입금 은행을 변경할 수 없습니다. 잠시 후 다시 시도해주세요.'

export const changeVirtualAccountBank = createAsyncThunk<
    {bankCode: BankCodeType; accountNo: string; depositorName: string},
    {orderNo: string; bankCode: BankCodeType}
>('orderTotal/changeVirtualAccountBank', async ({orderNo, bankCode}, {rejectWithValue}) => {
    try {
        const {
            result,
            bankCode: changedCode,
            accountNo,
            depositorName,
        } = await changeBank({
            orderNo,
            bankCode,
        })

        if (result && changedCode && accountNo) {
            return {bankCode: changedCode, accountNo, depositorName}
        } else {
            return rejectWithValue(Error(BankAccountChangeFailMessage))
        }
    } catch {
        return rejectWithValue(Error(BankAccountChangeFailMessage))
    }
})
